import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconUser = props => (
  <SvgIcon {...props} viewBox="0 0 21.6 25.559601">
    <path fillRule="evenodd" d="m16.2 5.4004c0-2.9883-2.412-5.4004-5.4-5.4004s-5.4 2.4121-5.4 5.4004c0 2.9873 2.412 5.3994 5.4 5.3994s5.4001-2.4121 5.4001-5.3994zm-16.2 14.364c2.322 3.4922 6.3 5.7959 10.8 5.7959s8.478-2.3037 10.8-5.7959c-0.054-3.5821-7.218-5.544-10.8-5.544-3.6 0-10.746 1.9619-10.8 5.544z" />
  </SvgIcon>
);

export default IconUser;



// WEBPACK FOOTER //
// ./src/components/icons/IconUser.js